module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-backoffice-category-list row column"
  }, [_c('div', {
    staticClass: "row column"
  }, [_c('base-list', {
    attrs: {
      "component": _vm.component,
      "dataLoader": _vm.dataLoader,
      "showPerPageSelect": false
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7f3cc689!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/TocList.vue
// module id = 2608
// module chunks = 1